<template>
  <div class="progressbar-container">
    <div class="progress-bar">
      <div class="progress-actual" :style="actualProgress"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
  computed: {
    actualProgress() {
      return 'width: ' + Math.min(100, this.progress) + '%;'
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.progress-bar-container {
  position: relative;
}
.progress-bar {
  height: 5px;
  border-radius: 3px;
  background-color: rgba($primary, 0.2);
}
.progress-actual {
  background-color: $primary;
  height: 5px;
  border-radius: 2px;
  transition: 0.3s all;
}
</style>